module.exports = __webpack_public_path__ + "static/media/hasard.f74d81b2.mp3";